import http from './httpRequest.js'

// 企微对企微（internal）发起会话 —— 选人/选号数据源（开关关闭时接口返回"功能未开启"）

// 我的企微账号列表（发起会话选号；多号时选择，顺序即选号优先级）
export function getMyWxworkAccounts() {
  return http({
    url: '/api/v1/customer/my_wxwork_accounts',
    method: 'get'
  })
}

// 内部同事列表（发起会话选人；keyword 模糊搜索，分页滚动加载）
export function getInternalContacts(params) {
  return http({
    url: '/api/v1/customer/internal_contacts',
    method: 'get',
    params
  })
}

// 企微好友列表（1688 外部联系人；keyword 模糊搜索，分页滚动加载）
export function getWxworkFriends(params) {
  return http({
    url: '/api/v1/customer/wxwork_friends',
    method: 'get',
    params
  })
}
